function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var toggleMenu = function toggleMenu() {
  var toggleBtn = document.querySelector('#menu-mobile-js-toggle');
  var menu = document.querySelector('#menu-mobile-js');
  toggleBtn.addEventListener('click', function () {
    if (toggleBtn.classList.contains('active')) {
      toggleBtn.classList.remove('active');
      menu.classList.remove('active');
    } else {
      toggleBtn.classList.add('active');
      menu.classList.add('active');
      var submenuItems = menu.querySelectorAll('.menu-item-drop, #Search, button');
      submenuItems.forEach(function (item) {
        item.tabIndex = 0;
      });
    }
  });
  document.addEventListener('keydown', function (event) {
    var mobileMenu = document.querySelector('#menu-mobile-js');
    var activeElement = document.activeElement;
    if (event.key === 'Escape' && toggleBtn.classList.contains('active') && (mobileMenu.contains(activeElement) || activeElement == toggleBtn)) {
      var _mobileMenu = document.querySelector('#menu-mobile-js');
      toggleBtn.click();
      toggleBtn.focus();
      var submenuItems = _mobileMenu.querySelectorAll('.menu-item-drop, #Search, button');
      submenuItems.forEach(function (item) {
        item.tabIndex = -1;
      });
    }
  });
};
var closeWhenScroll = function closeWhenScroll() {
  window.addEventListener('scroll', function () {
    closeSubmenus();
  });
};
var closeSubmenus = function closeSubmenus() {
  var submenus = document.querySelectorAll('.submenu.active');
  var menuItems = document.querySelectorAll('.menu-item.active');
  var submenuItems = document.querySelectorAll('.submenu-item');
  submenus.forEach(function (item) {
    item.classList.remove('active');
  });
  menuItems.forEach(function (item) {
    item.classList.remove('active');
  });
  submenuItems.forEach(function (item) {
    item.tabIndex = -1;
  });
};
var initMenu = function initMenu() {
  closeWhenScroll();
  toggleMenu();
  var menuItems = document.querySelectorAll('.menu-item-drop');
  menuItems.forEach(function (menuItem) {
    menuItem.addEventListener('click', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var link, submenu, submenuItems;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              link = e.target;
              if (link.getAttribute('href') == '#') {
                e.stopPropagation();
                e.preventDefault();
              }
              submenu = menuItem.parentNode.querySelector('.submenu');
              if (submenu) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!(submenu.classList.contains('active') && menuItem.parentNode.classList.contains('active'))) {
                _context.n = 2;
                break;
              }
              submenu.classList.remove('active');
              menuItem.parentNode.classList.remove('active');
              _context.n = 4;
              break;
            case 2:
              _context.n = 3;
              return closeSubmenus();
            case 3:
              submenu.classList.add('active');
              menuItem.parentNode.classList.add('active');
              submenuItems = submenu.querySelectorAll('.submenu-item');
              submenuItems.forEach(function (item) {
                item.tabIndex = 0;
              });
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
};
export { initMenu, closeSubmenus };